var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { NG_VALIDATORS } from '@angular/forms';
import { Attribute, Directive, forwardRef } from '@angular/core';
var MaxLengthValidatorDirective = /** @class */ (function () {
    function MaxLengthValidatorDirective(length) {
        this.length = length;
        this.validator = this.validateLengthFactory();
    }
    MaxLengthValidatorDirective_1 = MaxLengthValidatorDirective;
    MaxLengthValidatorDirective.prototype.validateLengthFactory = function () {
        var _this = this;
        return function (c) {
            if (c.value == null || c.value.length <= _this.length) {
                return null;
            }
            return { maxLength: _this.length };
        };
    };
    MaxLengthValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var MaxLengthValidatorDirective_1;
    MaxLengthValidatorDirective = MaxLengthValidatorDirective_1 = __decorate([
        Directive({
            selector: '[max-length][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return MaxLengthValidatorDirective_1; }), multi: true }
            ]
        }),
        __param(0, Attribute('max-length'))
    ], MaxLengthValidatorDirective);
    return MaxLengthValidatorDirective;
}());
export { MaxLengthValidatorDirective };
